export enum RouteShift {
  All = -1,
  Day = 0,
  Night = 1
}

export const RouteShiftMapping: Record<RouteShift, string> = {
  [RouteShift.All]: 'All',
  [RouteShift.Day]: 'Day',
  [RouteShift.Night]: 'Night'
};

export const RouteShiftODataMappingMapping: Record<RouteShift, string> = {
  [RouteShift.All]: "EBO.Models.LinehaulRoutes.RouteShift'All'",
  [RouteShift.Day]: "EBO.Models.LinehaulRoutes.RouteShift'Day'",
  [RouteShift.Night]: "EBO.Models.LinehaulRoutes.RouteShift'Night'"
};
